'use strict';

var _toConsumableArray2 = require('babel-runtime/helpers/toConsumableArray');

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

(function () {
	var FooterMobile = function () {
		function FooterMobile(node) {
			(0, _classCallCheck3.default)(this, FooterMobile);

			this.menu = node;
		}

		(0, _createClass3.default)(FooterMobile, [{
			key: 'init',
			value: function init() {
				var _this = this;

				[].concat((0, _toConsumableArray3.default)(this.menu.children)).forEach(function (item) {
					return item.querySelector('.first_lvl_menu > a').addEventListener('click', function (e) {
						e.preventDefault();
						var subMenuElem = item.querySelector('.sub_menu');
						if (item.classList.contains('open')) {
							item.classList.remove('open');
							_this.closeSubMenu(subMenuElem);
						} else {
							item.classList.add('open');
							_this.openSubMenu(subMenuElem);
						}
					});
				});
			}
		}, {
			key: 'openSubMenu',
			value: function openSubMenu(menu) {
				var height = this.getMenuHeight(menu);
				this.setHeight(height, menu);
			}
		}, {
			key: 'closeSubMenu',
			value: function closeSubMenu(menu) {
				this.setHeight(0, menu);
			}
		}, {
			key: 'getMenuHeight',
			value: function getMenuHeight(menu) {
				return [].concat((0, _toConsumableArray3.default)(menu.children)).reduce(function (acc, el) {
					return acc + el.offsetHeight + parseInt(window.getComputedStyle(el).marginBottom, 10);
				}, 0);
			}
		}, {
			key: 'setHeight',
			value: function setHeight(height, el) {
				Object.assign(el.style, {
					height: height + 'px'
				});
			}
		}]);
		return FooterMobile;
	}();

	var footerMenu = new FooterMobile(document.querySelector('.footer_menu'));
	footerMenu.init();
})();